/**
 * @author liushuai
 * @description 实现一个数值输入框
 */
import React, { ChangeEvent } from 'react';

export interface IProps {
    value: string | string[];
    placeholder?: string;
    isDisabled?: boolean;
    defaultValue?: string;
    className?: string;
    onChange(val: string | number): void;
    onBlur?(val: string): void;
}
import './numericInput.scss';
export const NumericInput = (props: IProps) => {
    const { className = '', placeholder = '', onChange, isDisabled = false } = props;
    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
        const { value } = e.target;
        const reg = /^-?\d*(\.\d*)?$/;
        if ((!isNaN(Number(value)) && reg.test(value)) || value === '' || value === '-') {
            onChange(value);
        }
    };
    const onBlur = (e: ChangeEvent<HTMLInputElement>) => {
        const { value } = e.target;
        if (props.onBlur) {
            const reg = /^-?\d*(\.\d*)?$/;
            if ((!isNaN(Number(value)) && reg.test(value)) || value === '' || value === '-') {
                props.onBlur(value);
            }
        }
    };
    return (
        <div className={`input ${className}`}>
            <input
                type="text"
                disabled={isDisabled}
                className="input"
                value={props.value}
                onBlur={onBlur}
                placeholder={placeholder}
                onChange={handleChange}
                spellCheck={false}
                autoComplete={'off'}
            />
        </div>
    );
};
